<template>
  <div>
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-if="analyticData && analyticData.length">
      <v-layout class="m-0" row wrap>
        <v-flex v-for="(data, index) in analyticData" :key="`cdp-log-${index + 1}`" xs12 class="mt-3">
          <div :style="{ fontWeight: 'bold' }">{{ data.product_name }}</div>
          <div>
            {{ dayjs(data.date).format('MMMM DD, YYYY') }} at
            {{ dayjs(data.date).format('h:mm a') }}
          </div>
        </v-flex>
        <v-divider class="my-2" />
      </v-layout>
    </template>
    <template v-else>
      <div class="text-center">ไม่พบข้อมูล</div>
    </template>
    <v-divider class="my-3" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

export default {
  components: {},
  props: {
    data: {
      value: undefined
    },
    userid: {
      value: undefined
    },
    pageid: {
      value: undefined
    }
  },
  data() {
    return {
      loading: false,
      demo: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    dayjs() {
      return dayjs
    },
    analyticData() {
      try {
        let output = []
        if (this.data && this.data.analytics) {
          const analytics = this.data.analytics
          try {
            if (analytics.analytics_purchase_history_list) {
              let analytics_purchase_history_list = analytics.analytics_purchase_history_list
              analytics_purchase_history_list = analytics_purchase_history_list.replaceAll(
                `'`,
                `"`
              )
              analytics_purchase_history_list = analytics_purchase_history_list.replaceAll(
                `product_name`,
                `"product_name"`
              )
              analytics_purchase_history_list = analytics_purchase_history_list.replaceAll(
                `date`,
                `"date"`
              )
              analytics_purchase_history_list = JSON.parse(
                analytics_purchase_history_list
              )
              analytics_purchase_history_list.forEach((purchaseHistory) => {
                output.push(purchaseHistory)
              })
            }
          } catch (error) {
            console.error(error)
          }
        }
        return output
      } catch (error) {
        console.error(error)
        return []
      }
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/DrMekCDPLog.vue